import script from "./FinanciamentosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanciamentosPage.vue?vue&type=script&setup=true&lang=js"

import "./FinanciamentosPage.vue?vue&type=style&index=0&id=2608a21d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2608a21d"]])

export default __exports__